<template>
  <div class="bg">
    <!-- 操作栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="goBackBox" @click="goBack"><img class="goBackIcon" src="@/assets/backIcon.svg" /><span class="goBackTitle">{{$t('message.backText')}}</span></div>
        <span class="goBackTitle marginLeft">{{$t('message.orderTableTitle1')}}：{{orderNum}}</span>
      </div>
    </div>
    <!-- 操作栏 -->
    <!-- 列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="logisticsList" :data="logisticsList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.goodsStatusTitle')" prop="HWZK" width="120"></el-table-column>
          <el-table-column :label="$t('message.deliveryStatusTitle')" prop="PSZK" width="120"></el-table-column>
          <el-table-column :label="$t('message.positionTitle')" prop="GUDING1" min-width="200"></el-table-column>
          <el-table-column :label="$t('message.uploadReceipt')" width="150">
            <template slot-scope="scope">
              <el-link v-if="scope.row.imgSrc !== ''" class="operation_a_blue" type="primary" :underline="false" target="_blank" :href="scope.row.imgSrc" >{{$t('message.customTableContent')}}</el-link>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.dateTitle')" prop="RQ" width="200"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 列表 -->
  </div>
</template>

<script>
  import { getLogistics, imgSrc2 } from '@/api/getData.js'
  export default {
    name: 'logisticsCheck',
    data () {
      return {
        orderNum: '',
        id: '',
        logisticsList: []
      }
    },
    created() {
      this.orderNum = this.$route.query.orderNum
      this.getLogistics()
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      // 查询物流信息
      async getLogistics () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { PID: this.orderNum }
        let res = await getLogistics(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.dt)
        let index = 0
        this.logisticsList = res.data.dt.map(item => {
          item.index = ++index
          item.imgSrc = !item.GUDING3 ? '' : imgSrc2(item.GUDING3)
          return item
        })
      }
    }
  }
</script>

<style scoped>
.marginLeft {
  margin-left: 45px;
  margin-right: 66px;
}
</style>
